import { axiosInstance } from '../Axios';
import axios from 'axios';
import { setSelectedOnwardFlight, setSelectedReturnFlight } from './UiReducer';
const { createSlice } = require('@reduxjs/toolkit');

const TBOReducer = createSlice({
	name: 'tbo',
	initialState: {
		success: false,
		error: null,
		loading: false,
		tboflight: null,
	},
	reducers: {
		TBOFlightRequest(state, action) {
			state.loading = true;
		},

		TBOFlightSuccess(state, action) {
			state.loading = false;
			state.tboflight = action.payload;
			state.error = null;
		},
		TBOFlightFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		fareRuleRequest(state, action) {
			state.loading = true;
		},
		fareRuleSuccess(state, action) {
			state.loading = false;
			state.farerule = action.payload;
			state.error = null;
		},
		fareRuleFail(state, action) {
			state.loading = true;
		},
	},
});

const { actions } = TBOReducer;
const config = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};
export const {
	TBOFlightRequest,
	TBOFlightSuccess,
	TBOFlightFail,
	fareRuleRequest,
	fareRuleSuccess,
	fareRuleFail,
} = actions;

export const SearchTBOFlightDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(TBOFlightSuccess(null));
		dispatch(setSelectedOnwardFlight(null));
		dispatch(setSelectedReturnFlight(null));
		dispatch(TBOFlightRequest());
		const { data } = await axiosInstance.post(
			'flytbo/flightsearch',
			bodyData,
			config
		);
		dispatch(TBOFlightSuccess(data));
	} catch (error) {
		dispatch(
			TBOFlightFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const FlightFareRuleTBODispatch =
	(ResultIndex, TraceId) => async (dispatch) => {
		try {
			let bodyData = {
				TraceId: TraceId,
				ResultIndex: ResultIndex,
			};
			dispatch(fareRuleRequest());

			const { data } = await axiosInstance.post(
				'FlyTbo/flightfarerule',
				bodyData,
				config
			);
			dispatch(fareRuleSuccess(data));
		} catch (error) {
			dispatch(
				fareRuleFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export default TBOReducer;
